import React from 'react'
import { getResponsiveImgProps } from 'src/comps/Gallery/utils'
import Image from 'src/comps/Image'
import { ImageApiObject } from 'src/types/image'
import IconPicture from 'client/icons/Picture'

import styles from './styles.module.css'

interface RoomImageProps {
  image: ImageApiObject
  alt: string
  imagesNumber?: number
  onClick: (event: React.UIEvent<HTMLElement>) => void
}

const boardImageSizes = {
  mobile: {
    size: '300px',
    srcWidth: 300,
  },
  tablet: {
    size: '218px',
    srcWidth: 218,
  },
  desktop: {
    size: '218px',
    srcWidth: 218,
  },
}

const RoomImage = ({ image, imagesNumber, alt, onClick }: RoomImageProps) => {
  return (
    <div
      className={styles.roomImageContainer}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <Image
        className={styles.roomImage}
        {...getResponsiveImgProps(image, boardImageSizes)}
        alt={alt}
        layout="cover"
        loading="lazy"
        width="100%"
        height="100%"
        dataTestId="room-image"
      />
      <div className={styles.roomImagesNumber}>
        <IconPicture size={14} />
        {imagesNumber}
      </div>
    </div>
  )
}

export default RoomImage
